export const ROLES = [
    { value: 'r', name: 'Read Only', },
    { value: 'rw', name: 'Evaluator' },
    { value: 'admin', name: 'Administrator' },
    { value: 'owner', name: 'Owner' },
    { value: 'guest', name: 'Guest' },
];
